var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidoNobooksFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.99 743.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_14",
    "data-name": "Camada 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.31,461.7c-46.71,14.08-209.18,128-81.24,156.38s182.78,12.18,337.12,36.55,199-113.73,67-180.6c-125.63-63.65-272.89-27.4-322.9-12.33",
    style: {
      fill: "#b7f9e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,499.4q-.56,2.76-1.17,5.38c-18.43,79.7-69,61-72.71,53-3.74-8.17-7.83-12.92-27.57-15s-19.75-13.28-21.11-20.77-19.4.34-24.51-8.85c-4.16-7.48,12.68-16.78,25.33-21.62h0a74.82,74.82,0,0,1,7.68-2.54l22.67-13.13c23.31-13.48,56.33-32.5,57-32.5s11.57,18,21,33.59c7.17,11.88,13.42,22.37,13.42,22.37",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,515.33c1.76,63.27-14.92,63.9-25.31,67.09-20.5,6.3-24.68,2.17-26.89-2-1.64-3.08-2.2-6.15-7.58-4.93-12.6,2.85-37.31,18.88-43.4,1-3.1-9.09-10.26-6.3-17.08-3.51-6.58,2.7-12.85,5.4-14.83-2.63-2.89-11.69,42.38-20.43,45.44-49,0,0,.33-4.16.82-9.21.7-7.34,1.71-16.63,2.5-18.36a4.76,4.76,0,0,1,1.39-1.47h0c5-3.91,21.14-10.79,21.14-10.79l66.16-20.21,1.15-.36c7.79,17.83-4.09,33.67-3.52,54.33",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,489.07a74.82,74.82,0,0,0-7.68,2.54c.46.54,15.26,17.3,43.06,17.59h2.47c24.5,0,64-3.42,75-4.43q.62-2.62,1.17-5.38l0-.06q-4.26.06-8.44.06c-53.95,0-99.67-6.85-105.58-10.33h0",
    style: {
      fill: "#a56e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.4,473.73C446,480,431.84,484.91,416.65,488.64a347,347,0,0,1-42.56,7.44c-.67,3.62-1.39,10.45-1.93,16.11a18.32,18.32,0,0,0,1.86.1,22.19,22.19,0,0,0,4.73-.55c19.63-4.25,65.69-21.6,79.65-38",
    style: {
      fill: "#a56e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,292.55c-25,12.81-40.95,37.17-43.28,46.15s2.89,27.24,21.64,56.76,19.52,29.51,4,38.05-7.42,26.8,17.65,28.74S185.05,454,185.05,454l-29-143.59-2.93-17.87",
    style: {
      fill: "#2c2a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.53,70.63A77.85,77.85,0,0,0,319,81a121,121,0,0,0,11.36,9.34h0l0,0,3.53,1.81L358.73,105s.31-3,.44-7.3v0c.21-7.32-.12-18.3-3.51-24.09-4.33-7.4-9.6-4.77-11.47,6.12v0a54.25,54.25,0,0,0-.7,9.17v0h0l0,0c-.83-1.61-18.14-34.85-32.33-34.85-8.91,0-8.64,7.15-1.59,16.71",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.53,69.35c1.68,0,3.47,1.36,5.13,4.18,2.9,5,3.56,13.71,3.56,20.72,0,1.18,0,2.32-.05,3.37-.14-.72-3.13-16.77-7.49-21.47a3.87,3.87,0,0,0-2.76-1.5c-2.9,0-4.73,5-4.73,5v0c1.15-6.73,3.61-10.3,6.34-10.3",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,54c14,1.55,30.48,33.22,31.29,34.79l0,0h0v0c-.54-1-17.21-33.28-31.32-34.84m-.08,0h0m0,0h0M312,54h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m-.08,0c-4.65,0-6.8,1.95-6.79,5.17,0-3.22,2.14-5.17,6.79-5.17h0",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,53.92h1c14,1.55,30.48,33.22,31.29,34.79l0,0h0c-.5-.67-16.64-22.39-24.32-23.33a23.08,23.08,0,0,0-2.62-.17c-4.21,0-6.41,1.63-7,5.31-3.38-4.57-5.2-8.59-5.2-11.54,0-3.22,2.14-5.17,6.79-5.17",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,88.86a150.15,150.15,0,0,1,19.09,1.52h0l0,0,3.53,1.81C327.34,91,316.27,89,311.27,88.86",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,81l17,10.28,3.12,1.89s-2.11-.42-5.21-1l-3.53-1.81,0,0h0A121,121,0,0,1,319,81",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.88,447.38a11.83,11.83,0,0,1-3.34,7.11,101.9,101.9,0,0,1-25.86,18.58h0c-12.66,6.61-27.3,11.7-43,15.56-84.41,20.75-200,6.11-209.65.43-1-.6-2-1.22-2.94-1.88-8.79-6.18-14.59-16.44-27.13-58.94v0c-3.54-12-7.63-26.6-12.47-44.4-2.4-8.83-4.35-17.67-5.9-26.41v-.1c-13.51-76.13,2.63-145.44,3.35-148.5h0l0-.09,8.62,8.21,126,120,149.36-92.62,8.75-5.42h0s-.12,16,0,37.59c0,5.66.1,11.71.19,17.95.14,11.35.38,23.34.74,34.84.24,7.77.55,15.32.92,22.29,0,.79.09,1.58.16,2.38a120.85,120.85,0,0,0,1.6,12.23,161.43,161.43,0,0,0,4.12,17.19A255.26,255.26,0,0,0,476,418.45l.1.2c2.34,5,4.63,9.49,6.69,13.4,1.74,3.28,3.33,6.14,4.66,8.47l0,.06a11.49,11.49,0,0,1,1.43,6.8",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.68,236.16c0,.38,0,.76,0,1.15s0,1,0,1.55a146.81,146.81,0,0,1-26.36,81.58,148.58,148.58,0,0,1-21.92,25A147.69,147.69,0,0,1,161.62,262.1a149.16,149.16,0,0,1,.26-53.28v0A147.74,147.74,0,0,1,307,88.49c1.15,0,2.3,0,3.44,0A147.68,147.68,0,0,1,454.68,236.16",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,88.86c-28.14,1.56-82.87,14.79-119.58,75.71-9.19,15.26-16.06,33.37-21.16,52.35a371.79,371.79,0,0,0-8.91,45.18c-5.79,42.23-4.9,81.13-3.09,95.22-13.51-76.13,2.63-145.45,3.35-148.5h0A147.73,147.73,0,0,1,307,88.49c1.15,0,2.3,0,3.44,0Z",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.89,239c-16-2.29-19.42-18.25-17.2-37.23.06-.53.12-1,.19-1.58a141.16,141.16,0,0,1,2.93-15.27c.42-1.72.89-3.42,1.39-5.06.15-.48.28-.95.43-1.41,7.07-22.18,20.74-37.58,32.15-35.31,12.47,2.49,17.5,25.24,11.23,50.8-.38,1.54-.74,3.07-1.12,4.59-.07.34-.17.68-.25,1l-.34,1.43c-.32,1.26-.63,2.52-.93,3.75-5.21,20.7-10.9,36.78-28.48,34.27",
    style: {
      fill: "#5d5dd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,118.05s-13.69,40.12,26.2,46.53l14.94-19.41s-31.76,2.85-41.14-27.12",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.21,111.37s4.17-42.69-41.51-48.48l-6.48,26.92S386.66,85.49,407.21,111.37Z",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,200.94c-.32,1.26-.63,2.52-.93,3.75-13.18-8.48-30.81-11.92-45.68-3,.06-.53.12-1,.19-1.58,12.1-8.44,27.37-8.32,40-3.62a38.35,38.35,0,0,0-35.68-16.71c.15-.48.28-.95.43-1.41,17-2.9,33.6,5.59,42.26,20.08-.16.65-.44,1.8-.59,2.45",
    style: {
      fill: "#56bee3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,256.76C218,265.15,203,268.4,186.72,264s-27.6-14.71-25.35-23.1,17.26-11.64,33.52-7.27,27.6,14.71,25.34,23.1",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,258.32s-3.36,37.05-43,30.79c-10.79-1.71-14.78-16.58-29-47,0,0,27.72,1.32,37.38,7.21l34.65,9",
    style: {
      fill: "#dd903c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,229.79c14.55,9.1,17.35,20.55,17.64,28.53,0,0-8,22.17-26.33,13.39s-26.88-27-62.26-28.32c10.86-12.1,46.8-28.7,71-13.6",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.28,197.49a119.67,119.67,0,0,0-3.4,28.39c0,.6,0,1.19,0,1.79.79-.27,1.58-.53,2.39-.78-.07-1.68-.11-3.37-.11-5.07a117.24,117.24,0,0,1,2.47-24l-1.36-.32m3-10.14c-.72,2.12-1.39,4.28-2,6.46.42.06.84.12,1.26.2.49-2,1-4,1.63-6-.29-.24-.59-.47-.89-.69m11.92-24.93a118.16,118.16,0,0,0-10.68,21.48q.41.24.81.51a115.83,115.83,0,0,1,10.05-21.92l-.18-.07",
    style: {
      fill: "#3c3c87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.77,157c-1.25,1.76-2.46,3.57-3.61,5.4l.18.07c1.09-1.86,2.24-3.69,3.43-5.47",
    style: {
      fill: "#a59b1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,193.81c-.34,1.22-.66,2.44-1,3.68l1.36.32c.27-1.28.55-2.54.86-3.8-.42-.08-.84-.14-1.26-.2m3.24-9.91c-.43,1.14-.84,2.29-1.24,3.45.3.22.6.45.89.69.37-1.22.75-2.43,1.16-3.63q-.4-.27-.81-.51",
    style: {
      fill: "#387b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.68,236.17c0,.38,0,.76,0,1.14h0c0-.38,0-.76,0-1.14h0",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,320.45q-2.2,3.17-4.58,6.21L446.49,360h0a28.71,28.71,0,0,0,6-2.68l-24.23-36.9h0",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87,288.87a119.26,119.26,0,0,0,154.36,43.67l-3.38-5a115.78,115.78,0,0,1-33.22,9.93c-1.22.19-2.45.34-3.69.47l-1.85.19-1.85.17-1.11.07c-.71.06-1.42.1-2.13.14h0l-1.32.05q-2.1.09-4.23.09h-.4q-6,0-11.95-.59h0q-2.93-.3-5.85-.75h0c-1.42-.22-2.84-.46-4.26-.73l-1-.19-.08,0c-.56-.09-1.11-.21-1.66-.34A.94.94,0,0,1,311,336l-1.74-.38-1.9-.46-1.88-.51c-.63-.16-1.25-.33-1.88-.52-1.26-.35-2.51-.74-3.75-1.16q-2.82-.9-5.58-2a113.43,113.43,0,0,1-19.77-9.82c-1.67-1-3.3-2.08-4.91-3.22L268,316.83c-.7-.5-1.4-1-2.09-1.54s-1.33-1-2-1.52-1.37-1.09-2.05-1.64l-.14-.11h0a115.78,115.78,0,0,1-20.84-22.35c-1.55-.11-3.16-.3-4.84-.56-.39-.07-.78-.15-1.15-.24m217.4-79.41,0,.16h0c0,.45.09.9.12,1.33s.1,1,.14,1.57c0,.29.05.56.06.83.07.81.12,1.64.16,2.46h0c.07,1.35.11,2.7.13,4.06,0,.61,0,1.22,0,1.83v.17a117.65,117.65,0,0,1-1.28,17.34c-.16,1-.32,2-.5,3v.08c-.18,1-.37,2-.58,3h0c-.2.93-.4,1.86-.61,2.79l0,.07c-.21.93-.44,1.88-.68,2.79s-.49,1.88-.75,2.79c-.16.54-.31,1.09-.48,1.62-.07.25-.15.5-.23.76-.14.46-.29.93-.44,1.41l-.3.91-.48,1.42c-.39,1.13-.81,2.27-1.24,3.41-.06.17-.13.33-.19.51-.22.54-.43,1.09-.65,1.63,0,.07-.05.13-.08.19a118.14,118.14,0,0,1-8,16.05h0l-1,1.71c-.68,1.13-1.4,2.23-2.15,3.33-.32.5-.66,1-1,1.46q-1.25,1.83-2.58,3.6c-.53.73-1.09,1.45-1.65,2.16h0a115.54,115.54,0,0,1-15.49,16.27l5.13,7.51,6.07,8.89q2.37-3,4.58-6.21l-7.25-11a119,119,0,0,0,14.06-17.27h0a117.77,117.77,0,0,0,10.11-18.37h0a117,117,0,0,0,9.22-34.25c0-.18.05-.37.07-.56h0c.07-.54.13-1.09.18-1.64h0c0-.38,0-.76,0-1.14a148.74,148.74,0,0,0-2.41-26.71",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.17,431h0a15.83,15.83,0,0,1-3.72,9.59h0a11.55,11.55,0,0,1,1.49,5.66,11.55,11.55,0,0,0-1.49-5.66,15.83,15.83,0,0,0,3.72-9.59",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.45,440.58a15.46,15.46,0,0,1-3.19,2.88,15.88,15.88,0,0,1-20.47-2.17h0l0,0c5.24,6.54,9.84,9.36,15.16,9.36a20.43,20.43,0,0,0,6.18-1.08,10,10,0,0,0,3.75-2.2c0-.38.05-.76.06-1.14a11.55,11.55,0,0,0-1.49-5.66h0m-27.66-4.77,0,.06,1.08,1.59,0,.07,0-.08-1.08-1.59,0-.05",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,249.85a118.26,118.26,0,0,0,15.58,39c.37.09.76.17,1.15.24,1.68.26,3.29.45,4.84.56l-.13-.18h0c-.54-.76-1.07-1.53-1.6-2.31h0c-.47-.69-.94-1.4-1.39-2.1l-.31-.5c-.44-.66-.86-1.34-1.28-2s-.64-1.08-1-1.62-.64-1.07-.95-1.63a115.49,115.49,0,0,1-9.9-23h0c-.46-1.51-.9-3-1.3-4.56-1.21-.66-2.45-1.3-3.75-1.91",
    style: {
      fill: "#8f5d27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,226.89c-.81.25-1.6.51-2.39.78a119.17,119.17,0,0,0,2.4,22.18c1.3.61,2.54,1.25,3.75,1.91a116.49,116.49,0,0,1-3.76-24.87",
    style: {
      fill: "#a56e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,488.63c-84.41,20.75-200,6.11-209.65.44-1-.61-2-1.22-2.94-1.88-15.12-28.3-32.82-88.74-24.53-111.06,6.61-17.78,41.36-15.25,76.39-12.72,17.32,1.25,34.71,2.5,48.79,1.29,42.57-3.63,54.59,2.61,60.69,26,6,22.84,24.7,57.6,51.25,97.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.17,431a15.88,15.88,0,0,1-27.38,10.31,16.08,16.08,0,0,1-1.61-2l-1.27-1.87-1.08-1.59-.78-1.13-2-2.88-4.56-6.68-8.68-12.69L413,367.25l-3.84-5.62h0l-2.9-4.25-2.43-3.56L390.71,334.7,383,323.35a16.08,16.08,0,0,1-1.71-3.25,15.89,15.89,0,0,1,27.95-14.69l1.68,2.46,6.76,9.9L446.49,360l15.92,23.3,9.59,14,10.08,14.75,1.41,2.05,4.93,7.22a16.09,16.09,0,0,1,2.37,5.4,15.26,15.26,0,0,1,.38,4.2",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.92,221.82a118,118,0,0,1-2.37,23.56c-.2.93-.4,1.86-.61,2.79l0,.07c-.21.93-.44,1.88-.68,2.79s-.49,1.88-.75,2.79c-.16.54-.31,1.09-.48,1.62-.07.25-.15.5-.23.76-.14.46-.29.93-.44,1.41l-.3.91-.48,1.42c-.39,1.13-.81,2.27-1.24,3.41-.06.17-.13.33-.19.51-.22.54-.43,1.09-.65,1.63-.57,1.41-1.17,2.82-1.8,4.21-.47,1.05-1,2.08-1.47,3.11-.17.35-.33.71-.51,1.06-.51,1-1.05,2-1.59,3.05l-.62,1.17c-.49.87-1,1.73-1.49,2.59l-.59,1.05-1,1.71c-.68,1.13-1.4,2.23-2.15,3.33-.32.5-.66,1-1,1.46q-1.25,1.83-2.58,3.6c-.53.73-1.09,1.45-1.65,2.16a117.27,117.27,0,0,1-28.68,26.13,2,2,0,0,1-.27.17c-.79.52-1.59,1-2.39,1.49-.62.38-1.25.75-1.88,1.12l-.25.14-1.62.92c-.55.31-1.1.6-1.64.91a116.07,116.07,0,0,1-38.63,12.65c-1.22.19-2.45.34-3.69.47l-1.85.19-1.85.17-1.11.07c-.71.06-1.42.1-2.13.14q-3,.13-5.95.14-6,0-11.95-.59-2.94-.32-5.85-.75c-1.76-.28-3.5-.57-5.23-.92l-.08,0c-.56-.09-1.11-.21-1.66-.34A.94.94,0,0,1,311,336l-1.74-.38-1.9-.46-1.88-.51c-.63-.16-1.25-.33-1.88-.52-1.26-.35-2.51-.74-3.75-1.16q-2.82-.9-5.58-2a113.43,113.43,0,0,1-19.77-9.82c-1.67-1-3.3-2.08-4.91-3.22L268,316.83c-.7-.5-1.4-1-2.09-1.54s-1.33-1-2-1.52-1.37-1.09-2.05-1.64l-.14-.11a118.59,118.59,0,0,1-21-22.53c-.54-.76-1.07-1.53-1.6-2.31h0c-.47-.69-.94-1.4-1.39-2.1l-.31-.5c-.44-.66-.86-1.34-1.28-2s-.64-1.08-1-1.62-.64-1.07-.95-1.63a115.49,115.49,0,0,1-9.9-23h0a116.89,116.89,0,1,1,226.94-54c.14.79.26,1.6.39,2.4v.08c.24,1.6.44,3.21.61,4.83,0,.45.09.9.12,1.33s.1,1,.14,1.57c0,.29.05.56.06.83.07.81.12,1.64.16,2.46q.15,3,.15,6",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.22,221.82a112.07,112.07,0,0,1-.77,13.16,116.94,116.94,0,0,1-197.31,59,111.69,111.69,0,0,1-26.26-72.12c0-2.44.08-4.86.24-7.24a112.18,112.18,0,0,1,168.71-89.51h0a112.11,112.11,0,0,1,55.37,96.74",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.41,156.08c.43-.64.87-1.27,1.32-1.91l-.57,1.11C239.9,155.54,239.65,155.82,239.41,156.08Z",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,152.08a104.24,104.24,0,0,0-21.37,42.32,1,1,0,0,0,.21.91,111.63,111.63,0,0,1,21.16-43.23m90-42.52q-2.91,0-5.82.15c1.23,0,2.47-.06,3.71-.06a111.72,111.72,0,0,1,39.36,7.11,1,1,0,0,0-.62-.62,103.72,103.72,0,0,0-36.63-6.58",
    style: {
      fill: "#f07f93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05,109.65c-1.24,0-2.48,0-3.71.06a119.12,119.12,0,0,0-84.14,42.37A111.63,111.63,0,0,0,227,195.31a1.09,1.09,0,0,0,.81.36,1,1,0,0,0,.93-.7c16.12-48.31,63.09-81.28,113.74-81.28a116.19,116.19,0,0,1,31.64,4.39,1.15,1.15,0,0,0,.31,0,1,1,0,0,0,.94-1.36,111.72,111.72,0,0,0-39.36-7.11",
    style: {
      fill: "#f07f93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.49,221.83a93.45,93.45,0,1,1-93.44-93.45,93.43,93.43,0,0,1,93.44,93.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,222.75c0,30.86-13.58,55.87-30.35,55.87s-30.34-25-30.34-55.87,13.58-55.87,30.34-55.87,30.35,25,30.35,55.87",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,315.27h0m-.25,0h0m-.23,0h0m-.26,0h0m-.23,0h0m-.26,0h0m-.26,0h0m-.24,0h0m-.25,0h0m-.28,0h0m-.5,0h0m-20.87-3a93.27,93.27,0,0,0,20.87,3,93.27,93.27,0,0,1-20.87-3m-.15,0,.09,0-.09,0m60.9-4.44a93.13,93.13,0,0,1-36.86,7.55h0a93.13,93.13,0,0,0,36.86-7.55m0,0h0M244.19,239.1v0m15.16-70.68A93.75,93.75,0,0,0,244.18,239a93.75,93.75,0,0,1,15.17-70.62",
    style: {
      fill: "#d4a3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05,128.38A93.54,93.54,0,0,0,244.18,239v.08a92.52,92.52,0,0,0,8,24,93.66,93.66,0,0,0,54.06,47.31q2.83,1,5.75,1.74l.09,0h.06a93.27,93.27,0,0,0,20.87,3h3a93.13,93.13,0,0,0,36.86-7.55h0a93.58,93.58,0,0,0,50.9-117.93h0l-64.3,66c-5.09,12.77-13.05,21.42-22.13,22.71l-31.16,32a93.66,93.66,0,0,1-54.06-47.31l52.87-49.05c2.27-26.73,14.83-47.18,30-47.18,5.07,0,9.85,2.29,14.05,6.34l34.39-31.91a93,93,0,0,0-47.44-12.93",
    style: {
      fill: "#def4f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,255.75l-22.13,22.71c9.08-1.29,17-9.94,22.13-22.71m-24.5-88.87c-15.15,0-27.71,20.45-30,47.18l44-40.84c-4.2-4.05-9-6.34-14.05-6.34",
    style: {
      fill: "#61787d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.77,184.57v0m-.11-.25,0,.05,0-.05m-.11-.26,0,.08,0-.08m-.12-.26.07.16-.07-.16m-.13-.29.1.23c0-.08-.07-.16-.1-.23m-4.75-9.15a93,93,0,0,1,4.75,9.14,93,93,0,0,0-4.75-9.14m-.12-.21a1.62,1.62,0,0,1,.1.18,1.62,1.62,0,0,0-.1-.18m-.1-.16.06.09-.06-.09m-.12-.22,0,.08,0-.08m-.13-.2,0,0,0,0m-.11-.19h0",
    style: {
      fill: "#dcc4d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07,214.06,252.2,263.11a93.66,93.66,0,0,0,54.06,47.31l31.16-32a17,17,0,0,1-2.37.16c-16.76,0-30.34-25-30.34-55.87,0-2.95.12-5.86.36-8.69m78.42-72.75L349.1,173.22c9.69,9.33,16.3,28,16.3,49.53a90.43,90.43,0,0,1-5.85,33l64.3-66c-.64-1.75-1.33-3.47-2.07-5.18v0l-.09-.2,0-.05-.08-.18,0-.08-.05-.1-.07-.16,0-.06-.1-.23h0a93,93,0,0,0-4.75-9.14l0,0a1.62,1.62,0,0,0-.1-.18l0-.07-.06-.09-.08-.14,0-.08-.1-.16,0,0-.11-.18h0a94,94,0,0,0-32.48-32.07h0",
    style: {
      fill: "#e4f8fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,173.22l-44,40.84c-.24,2.83-.36,5.74-.36,8.69,0,30.86,13.58,55.87,30.34,55.87a17,17,0,0,0,2.37-.16l22.13-22.71a90.43,90.43,0,0,0,5.85-33c0-21.52-6.61-40.2-16.3-49.53",
    style: {
      fill: "#7aa4ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.49,414.17a78,78,0,0,1-7.52,4.28,65.08,65.08,0,0,1-18.89,6.19c-.8.14-1.6.24-2.4.33l-2.16.21,2.43,3.55,4.1,6c11.33-.46,24.1-2.38,31.74-8a16.09,16.09,0,0,0-2.37-5.4h0l-4.93-7.21",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.29,368.67c-2.26,17.84-15.32,34.86-31.8,45.5a78,78,0,0,1-7.52,4.28,65.08,65.08,0,0,1-18.89,6.19c-.8.14-1.6.24-2.4.33l-2.16.21C426.76,427.4,407.05,417,398.21,396l0,0c-.33-.79-.65-1.6-.95-2.42a34.21,34.21,0,0,1-2.06-16.67,29.43,29.43,0,0,1,2.42-8.29v0a31.41,31.41,0,0,1,3.66-6.08,27.56,27.56,0,0,1,4.93-5.08l2.9,4.25h0c.34.28,9.28,7.44,37.38-1.61,4.8-1.55,8.06-3.68,10.2-6.12,8.17-9.29,0-22.93-1.08-24.67l-.12-.18-13-18.63,6.23-17.31,6-16.67c32.59,7,48.18,26.53,55.41,46v0a91.36,91.36,0,0,1,4.32,16.22h0a106.38,106.38,0,0,1,.88,30",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.23 332.54 389.23 332.54 390.71 334.69 389.23 332.54",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,338.7h0m5.55-.14-1.32.05,1.32-.05m-23.75-1.2q2.92.45,5.85.75-2.94-.32-5.85-.75m-4.26-.73c1.42.27,2.84.51,4.26.73-1.43-.22-2.85-.46-4.26-.73m71.86-9h0l3.38,5h0l-3.38-5M428,294a117.42,117.42,0,0,1-15.5,16.26h0A115.54,115.54,0,0,0,428,294m-187.13-4.32A115.78,115.78,0,0,0,261.7,312a118.16,118.16,0,0,1-20.84-22.35h0m203.54-24c-.54,1.35-1.12,2.69-1.72,4-.47,1.05-1,2.08-1.47,3.11-.17.35-.33.71-.51,1.06-.51,1-1.05,2-1.59,3.05l-.62,1.17c-.49.87-1,1.73-1.49,2.59l-.59,1.05a118.14,118.14,0,0,0,8-16.05m6.74-23.43c-.18,1.05-.38,2.09-.59,3.13.21-1,.4-2,.58-3v-.08m1.76-22.38c0,.65,0,1.3,0,1.95a118.64,118.64,0,0,1-1.28,17.39,117.65,117.65,0,0,0,1.28-17.34v-.17c0-.61,0-1.22,0-1.83",
    style: {
      fill: "#1b1b40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.73,289.49l.13.18h0l-.13-.18",
    style: {
      fill: "#5d3c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.49,310.25a116.61,116.61,0,0,1-13.18,9.87,2,2,0,0,1-.27.17c-.79.52-1.59,1-2.39,1.49-.62.38-1.25.75-1.88,1.12l-.25.14-1.62.92c-.55.31-1.1.6-1.64.91q-2.67,1.42-5.41,2.72l3.38,5,1.48,2.16,26.92-16.93-5.13-7.5h0",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.37,183.24A116.8,116.8,0,0,1,447.45,235h0a112.17,112.17,0,0,1-197.31,59h0a115.58,115.58,0,0,1-19.54-26c-.79-1.44-4.83-8.83-6.25-11.57a115.49,115.49,0,0,0,9.9,23l0,0c.3.54.61,1.07.92,1.6s.63,1.07,1,1.62.84,1.37,1.28,2l.31.5c.45.7.92,1.41,1.39,2.1h0c.53.78,1.06,1.55,1.6,2.31h0l.13.18A118.16,118.16,0,0,0,261.7,312h0l.14.11c.68.55,1.36,1.1,2.05,1.64s1.31,1,2,1.52,1.39,1,2.09,1.54l1.59,1.11c1.6,1.12,3.24,2.18,4.91,3.22l1.69,1A117.61,117.61,0,0,0,294.23,331c1.85.71,3.71,1.38,5.58,2,1.25.41,2.5.79,3.75,1.16.63.19,1.25.36,1.88.52l1.88.51,1.9.46L311,336a.94.94,0,0,0,.32.08c.55.13,1.1.25,1.66.34l.08,0,1,.19c1.41.27,2.83.51,4.26.73h0q2.91.43,5.85.75h0c1.2.12,2.4.21,3.61.29q.94.08,1.89.12c.51,0,1,.05,1.55.08,1.33,0,2.67.08,4,.1h1.3c.68,0,1.37,0,2,0l2.19-.06,1.32-.05h0c.71,0,1.42-.08,2.13-.14l1.11-.07,1.85-.17,1.85-.19c1.23-.13,2.46-.29,3.69-.47a117.32,117.32,0,0,0,33.21-9.95v0h0q2.75-1.29,5.41-2.72c.54-.31,1.09-.6,1.64-.91l1.62-.92.25-.14c.63-.37,1.26-.74,1.88-1.12.8-.49,1.6-1,2.39-1.49a2,2,0,0,0,.27-.17A117,117,0,0,0,428,294h0c.56-.71,1.12-1.43,1.65-2.16q1.33-1.77,2.58-3.6c.34-.48.68-1,1-1.46.74-1.1,1.45-2.2,2.15-3.33l1-1.71h0l.59-1.05c.51-.86,1-1.72,1.49-2.59l.62-1.17c.54-1,1.08-2,1.59-3.05.18-.35.34-.71.51-1.06.5-1,1-2.06,1.47-3.11.6-1.33,1.18-2.67,1.72-4,0-.06.05-.12.08-.19.22-.54.43-1.09.65-1.63.06-.18.13-.34.19-.51.43-1.14.85-2.28,1.24-3.41l.48-1.42.3-.91c.15-.48.3-.95.44-1.41.08-.26.16-.51.23-.76.17-.53.32-1.08.48-1.62q.39-1.37.75-2.79c.24-.91.47-1.86.68-2.79l0-.07c.21-.93.41-1.86.61-2.79h0c.21-1,.41-2.08.59-3.13.13-.73.24-1.47.36-2.21,0-.21.07-.43.11-.64l0-.19a118.64,118.64,0,0,0,1.28-17.39c0-.65,0-1.3,0-1.95,0-.33,0-.67,0-1,0-1-.06-2-.11-3.06h0c0-.82-.09-1.65-.16-2.46,0-.27,0-.54-.06-.83,0-.53-.08-1-.14-1.57s-.07-.88-.12-1.33h0c-.17-1.62-.38-3.23-.61-4.83h0v-.08c-.13-.8-.25-1.61-.39-2.4h0a117.07,117.07,0,0,0-4.91-19.07",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.91,330a4.43,4.43,0,0,0-3.67,6.89l15,22.27a4.42,4.42,0,1,0,7.34-4.94l-15-22.27a4.44,4.44,0,0,0-3.67-2",
    style: {
      fill: "#f07f93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.2,357.37a23,23,0,0,0-2.55,2.32l-.09.09a22.68,22.68,0,0,1,2.64-2.4l2.9,4.25h0l-2.9-4.25",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.2,357.37h0l2.9,4.25h0c.25.2,3.73,2.95,12.87,2.95,5.73,0,13.7-1.08,24.49-4.56h0c-10.8,3.48-18.77,4.57-24.51,4.57-9.19,0-12.66-2.78-12.87-3h0l-2.9-4.25",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.2,357.38a22.68,22.68,0,0,0-2.64,2.4,3,3,0,0,0,.85,4.59,28.16,28.16,0,0,0,8.54,2.88,32.53,32.53,0,0,0,5.71.48c7.06,0,16.12-2,27.81-7.7-10.79,3.48-18.76,4.56-24.49,4.56-9.14,0-12.62-2.75-12.87-2.95h0l-2.9-4.25",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.18,376.85c-2.73,14.61-1.63,39.9,20.36,50.67,12.33,6,22.07,7.66,29,7.66,8.23,0,12.53-2.3,12.53-2.3v-1L455,428.73l-2.43-3.55c-2.29.19-4.52.29-6.71.29-22.46,0-39.55-10.32-47.6-29.5l0,0c-.33-.79-.65-1.6-.95-2.42a36,36,0,0,1-2.35-12.47,29.68,29.68,0,0,1,.29-4.2",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "452.52 425.18 452.52 425.18 452.52 425.18 454.95 428.74 452.52 425.18",
    style: {
      fill: "#1b1b40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.89,381.05a36,36,0,0,0,2.35,12.47c.3.82.62,1.63.95,2.42l0,0c8.05,19.18,25.14,29.5,47.6,29.5,2.19,0,4.42-.1,6.71-.29h0c-2.29.2-4.52.3-6.71.3-22.46,0-39.55-10.32-47.6-29.51l0,0c-.33-.79-.65-1.61-.95-2.42a36,36,0,0,1-2.35-12.47",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,368.88a1.56,1.56,0,0,0-.92.31c-9.34,6.64-22.67,8.25-33.43,8.25a118.11,118.11,0,0,1-15-1l-.23,0a1.62,1.62,0,0,0-1.25,2.63c2.4,2.87,8.31,6.71,22.74,6.71.87,0,1.77,0,2.71,0,13.3-.41,21.68-7.51,26.67-14.25a1.64,1.64,0,0,0-1.29-2.61",
    style: {
      fill: "#4d4dad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.66,473.07c-12.85,5.33-28.38,9.24-45.33,12,.77,1.18,1.54,2.36,2.32,3.54h0c15.71-3.86,30.35-8.94,43-15.56M176.93,428.24c12.54,42.5,18.34,52.76,27.13,58.95a203.61,203.61,0,0,1-10.39-23.48c-9-11.09-12-24.43-16.74-35.47",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,463.71a203.61,203.61,0,0,0,10.39,23.48h0c.94.66,1.92,1.27,2.94,1.88,5.91,3.48,51.62,10.32,105.58,10.32,34.06,0,71.4-2.73,104.07-10.76-.78-1.18-1.55-2.36-2.32-3.54-26,4.28-55.4,5.9-83.38,5.9-40.06,0-77.31-3.32-98-6.89-20.2-3.5-31.82-11.17-39.3-20.39",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.65,238.86h0a147,147,0,0,1-11.15,53.79c2.5.17,4.53.34,5.2.47h0l6-16.67c-.06-8.31-.08-15.78-.08-21.84,0-9.69,0-15.75,0-15.75",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.64,238.86l-.15.09h0c0,.19,0,.38-.07.56a117,117,0,0,1-9.22,34.25h0a117.77,117.77,0,0,1-10.11,18.37c2.62.15,5.77.33,8.4.51a147,147,0,0,0,11.15-53.79h0",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.68,276.45h0l-6,16.67c1.61.29,3.71.7,6.18,1.28,17.33,4,52.55,15.56,59.54,44.3a91.36,91.36,0,0,0-4.32-16.22v0c-7.23-19.48-22.82-39-55.41-46",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 637.99,
    height: 743.31,
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidoNobooksFound);
export default __webpack_public_path__ + "static/media/guido_nobooks_found.5e9ed1aec759a0f5dd303653a0b17a18.svg";
export { ForwardRef as ReactComponent };